import React from 'react';
import styled from 'styled-components';
import Thumbnail from '../components/Thumbnail';
import { ThumbnailContainer } from '../components/Thumbnail';
import { Link } from "react-router-dom";
import TextBlockOben from '../components/TextBlockOben';

const ListContainer = styled.div`
  margin: auto;
  display: inline-block;
  padding-right: 40px
`;

const Home = (props) => (
  <TextBlockOben>
    <h1>Herzlich willkommen!</h1>
    <p>Ich liebe Wolle und deren vielseitige Möglichkeiten.
    </p>
    
      <ListContainer>
        <ul>
          <li> <Link to="/galerie/Sitzkissen">Sitzkissen</Link> - handgefilzt aus reiner Schafwolle<br /><br /></li>
          <li> <Link to="/galerie/Wolle">Wolle</Link> - handgesponnen und handgefärbt <br /><br /></li>
          <li> <Link to="/galerie/strickereien">Strickereien</Link> - zum Wohlfühlen im Alltag<br /><br /></li>
          <li> <Link to="/galerie/Accessoires">Accessoires</Link> - allerlei von, für und mit Wolle.<br /><br /><br /></li>
        </ul>
      </ListContainer>
    <p>Auf meiner Website findet Ihr Beispiele meines Angebotes.<br /><br /> 
        Wenn Ihr mich und meine aktuellen Produkte vor <Link to="/termine/">Ort  </Link> 
        kennenlernen möchtet,<br /><br />
        freue ich mich auf Euren Besuch an meinem Stand.<br /><br /> 
        <br />
    </p>

    <ThumbnailContainer width={280}>
      <Thumbnail title="Sitzkissen einheimischer Schafe" src={require('../images/Kollage_WollKi.png')} />
      <Thumbnail title="Wolle unterschiedlicher Tierrassen" src={require('../images/Wolle_gesamt_home.png')} />
      <Thumbnail title="Strickereien zum Wohlfühlen" src={require('../images/Strickereien_Handstulpen.png')} />
      <Thumbnail title="Accessoires - Die kleinen Helferlein" src={require('../images/Gruppe_Holz_Home.png')} />
    </ThumbnailContainer>
  </TextBlockOben>
);

export { Home };
